var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6429 9.56882C19.5862 5.33313 16.1973 1.94565 12.0714 2.00066L11.8296 2.00138C7.81396 2.07882 4.55553 5.41618 4.5 9.56882C4.50174 11.2136 5.03425 12.8114 6.01429 14.1125L10.8233 21.3274L10.9091 21.4438C11.3915 22.0364 12.2546 22.1761 12.9034 21.7436C13.0682 21.6337 13.2097 21.4923 13.3196 21.3274L18.1286 14.1125L18.3186 13.8484C19.1773 12.5982 19.6412 11.1039 19.6429 9.56882ZM6 9.56724C6.04555 6.17282 8.76286 3.45668 12.0514 3.50053L12.3147 3.50179C15.5021 3.5805 18.0983 6.25046 18.143 9.58888C18.1415 10.8878 17.7144 12.1693 16.9304 13.2101L12.0714 20.4955L7.26243 13.2806L7.08996 13.0399C6.36964 11.986 6.0013 10.7935 6 9.56724Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.5C15 7.84315 13.6569 6.5 12 6.5C10.3431 6.5 9 7.84315 9 9.5C9 11.1569 10.3431 12.5 12 12.5C13.6569 12.5 15 11.1569 15 9.5ZM10.5 9.5C10.5 8.67157 11.1716 8 12 8C12.8284 8 13.5 8.67157 13.5 9.5C13.5 10.3284 12.8284 11 12 11C11.1716 11 10.5 10.3284 10.5 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapHover);
export default __webpack_public_path__ + "static/media/mapHover.07524c2036b937f0d9e0c6ea66454372.svg";
export { ForwardRef as ReactComponent };